import { render, staticRenderFns } from "./OverviewPart.vue?vue&type=template&id=23799348&scoped=true"
import script from "./OverviewPart.vue?vue&type=script&lang=js"
export * from "./OverviewPart.vue?vue&type=script&lang=js"
import style0 from "./OverviewPart.vue?vue&type=style&index=0&id=23799348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23799348",
  null
  
)

export default component.exports